import React from "react"
import "./blockBooking.scss"
import { useIntl } from "gatsby-plugin-react-intl"

const BookingFooter = ({ locale }) => {
  const intl = useIntl()

  //Handle Booking Layout
  const toggleBookingForm = () => {
    const contBookingBlock = document.querySelector(".bookingBar")
    contBookingBlock.classList.toggle("show")
  }

  return (
    <section className="bookingFooter" onClick={toggleBookingForm}>
      <div className="bookingFooter-content">
        <p>
          {
            locale === "en" ? (
              <>Book Now</>
            ) : (
              <>Réserver maintenant</>
            )
          }
        </p>
      </div>
    </section>
  )
}

export default BookingFooter
